// TODO: change it when backend will be ready
const dateFormatOptions = [
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
  { value: 'YYYY/MM/DD', label: 'YYYY/MM/DD' },
];

export default dateFormatOptions;
